<template>
  <div class="px-2 py-1 border border-gray-100 bg-white my-1">
    <header class="flex justify-between items-center">
      <div class="flex items-center pr-5">
        <span
          v-text="i18n.project.replace(':id', data.id)"
          class="whitespace-no-wrap w-40"
        ></span>
        <input v-model="filename" class="w-48" />
      </div>
      <div class="">
        <progress-bar
          :progress="data.progress"
          class="w-full"
          v-if="data.progress > 0"
        ></progress-bar>
      </div>
      <div class="flex justify-end items-center">
        <ranch-button
          @click="use"
          :label="i18n.reuse"
          :icon="['fas', 'file-export']"
          v-if="!uploading && !completed"
        ></ranch-button>
        <font-awesome-icon icon="spinner" spin v-if="uploading" />
        <span
          class="text-xs w-5 h-5 rounded-full bg-green-500 flex justify-center items-center text-white"
          v-if="completed"
        >
          <font-awesome-icon icon="check"></font-awesome-icon>
        </span>
      </div>
    </header>
    <div class="py-1" v-if="hasError">
      <alert
        level="error"
        :message="data.error"
        class="py-1 px-2 text-sm"
      ></alert>
    </div>
  </div>
</template>

<script>
import ProgressBar from "../../Design/ProgressBar";

export default {
  props: ["data", "i18n"],
  components: { ProgressBar },
  mixins: [],
  data: function () {
    return {
      filename: this.data.filename,
    };
  },
  methods: {
    use() {
      this.$emit("re-use", { ...this.data, filename: this.filename });
    },
  },
  computed: {
    hasError() {
      return this.data.error !== undefined;
    },
    uploading() {
      return this.data.status === "working";
    },
    completed() {
      return this.data.status === "completed";
    },
  },
  mounted() {},
};
</script>

<style></style>
